export default {
      id: "oc-res-mount-target-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-mount-target",
      toString: function () {
        return this.url;
      }
    }